import {useState, useContext, useEffect} from "react"
import Button from "react-bootstrap/Button"
import Modal from "react-bootstrap/Modal"
import {Spinner} from "react-bootstrap"

import RefContext from "../utilities/RefContext"
import {wrappedPost} from "../utilities/AxiosHelper"

const AddFacilityModal = ({showModal = false, closeModal, organizationId}) => {
    const {dispatch} = useContext(RefContext)

    const [show, setShow] = useState(false)
    const [facility, setFacility] = useState({name: "", active: true, customerKey: ""})
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setShow(showModal)
    }, [showModal])

    const handleClose = () => {
        setShow(false)
        closeModal()
    }

    const handleSave = () => {
        setIsLoading(true)
        wrappedPost(`organization/${organizationId}/facility`, facility)
            .then((response) => {
                dispatch("showToast", {
                    show: true,
                    variant: "success",
                    text: "Facility Updated",
                    timeout: 5000,
                })
            })
            .catch((error) => {
                dispatch("showToast", {
                    show: true,
                    variant: "danger",
                    text: "Problem saving Facility",
                    timeout: 5000,
                })
            })
            .finally(() => {
                setIsLoading(false)
                closeModal()
            })
    }

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Add New Facility</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoading && (
                    <div className="d-flex justify-content-center align-items-center vh-100">
                        <div className="d-flex align-items-center">
                            <span className="me-2">Please wait...</span>
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        </div>
                    </div>
                )}

                {!isLoading && (
                    <div className="row g-8 p-8 d-flex flex-row align-items-end">
                        <div className="col">
                            <div className="row g-8 align-items-end">
                                <div className="col-12">
                                    <h3>Facility</h3>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="id-facility-name" className="form-label fw-bold">
                                        Facility Name:
                                    </label>
                                    <input
                                        id="id-facility-name"
                                        type="text"
                                        className="form-control form-control-solid ps-12 required"
                                        placeholder="Name"
                                        value={facility.name}
                                        onChange={(evt) => {
                                            setFacility((prev) => ({
                                                ...prev,
                                                name: evt.target.value,
                                            }))
                                        }}
                                    />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="id-facility-customer-key" className="form-label fw-bold">
                                        Customer Key:
                                    </label>
                                    <input
                                        id="id-facility-customer-key"
                                        type="text"
                                        className="form-control form-control-solid ps-12"
                                        placeholder="Key"
                                        value={facility.customerKey}
                                        onChange={(evt) => {
                                            setFacility((prev) => ({
                                                ...prev,
                                                customerKey: evt.target.value,
                                            }))
                                        }}
                                    />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="id-facility-active" className="form-label fw-bold">
                                        Active:
                                    </label>
                                    <select
                                        className="form-select form-select-solid fw-bold"
                                        id="id-facility-active"
                                        checked={facility.active}
                                        onChange={(evt) => {
                                            setFacility((prev) => ({
                                                ...prev,
                                                active: evt.target.value === 'true',
                                            }))
                                        }}
                                    >
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSave}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddFacilityModal
